import ApartmentAutocomplete from './ApartmentAutocomplete';

export default ApartmentAutocomplete;
